import type { FaireProductEntity } from "../../entity_types/product";

export const p_6zexdpn5ef: FaireProductEntity = {
  token: "p_6zexdpn5ef",
  type: "product",
  name: "Halloween Critters greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/26f3e07c3dc3c138431400b1fef1b014ea8b82639b6d10f64c0f53f9e31228f1.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.75,
  description:
    "• Illustrated by The House That Lars Built\n• A2 - 4.25 x 5.5 inch\n• Heavyweight Uncoated Cardstock\n• Printed in Full Color\n• Blank Interior\n• Matching Envelope\n• Sold as Single Card\n• Printed in the USA",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:41.673Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
